import { ActionFeedbackDialog } from '../../../../../components/ActionFeedbackDialog';

type CampaignTypeDeleteModalProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const CampaignTypeDeleteModal = ({ open, onCancel, onConfirm }: CampaignTypeDeleteModalProps) => {
  return (
    <ActionFeedbackDialog
      open={open}
      type="warning"
      title="Excluir campanha"
      onClose={onCancel}
      description={
        <p>
          Você está tentando deletar uma campanha.
          <br />
          <strong> Você confirma essa ação?</strong>
        </p>
      }
      secondaryAction={{ label: 'Cancelar', onClick: onCancel }}
      primaryAction={{
        label: 'Excluir',
        onClick: () => {
          onConfirm();
          onCancel();
        },
      }}
    />
  );
};
